import { ServiceCategory } from '../services/types'

export type Employee = {
  id: number
  guid: string
  vorname: string
  nachname: string
  beschreibung: string
  fotoUrl: string
  title: string
  servicesKategorien: ServiceCategory[]
}

export enum EmployeesActionTypes {
  FETCH_REQUEST = '@@employees/FETCH_REQUEST',
  FETCH_SUCCESS = '@@employees/FETCH_SUCCESS',
  FETCH_ERROR = '@@employees/FETCH_ERROR',
  SELECT_EMPLOYEE = '@@employees/SELECT_EMPLOYEE',
  CLEAR_SELECTED = '@@employees/CLEAR_SELECTED'
}

// Declare state types with `readonly` modifier to get compile time immutability.
// https://github.com/piotrwitek/react-redux-typescript-guide#state-with-type-level-immutability
export interface EmployeesState {
  readonly loading: boolean
  readonly data: Employee[]
  readonly selected?: Employee
  readonly errors?: string
}
